Confirm = require 'views/lib/confirm'
PopOver = require 'views/lib/pop-over'
l = require 'lib/localize'
track = require 'debug/track'

module.exports = ({ trackingArea, elem, message, params }) ->
  track(trackingArea, "Denied", message)
  Confirm.toggle message,
    elem: elem
    html: l "confirm.#{message}.text", params
    fxConfirm: => PopOver.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/lib/limit-error-popover.coffee